/**
 * @lodex-pro/web-portal/routes/DisposalBiDashboard — Phase 16 / Task 16.6 (DEC-163).
 *
 * The disposal-portal BI dashboard mounted at /portal/disposal/bi. Renders the
 * three MVP §55 modules whose data prerequisites exist today:
 *   - VolumeTrendsPanel        (module_volume_trends)
 *   - AcceptanceBySitePanel    (module_acceptance_by_site)
 *   - DataExportPanel          (module_data_export)
 *
 * Per §49, disabled modules are invisible in the portal — the panels probe
 * their endpoints and hide themselves if the API returns
 * `DISPOSAL_BI_MODULE_NOT_ACTIVE`. If ALL three probes return 409 (or the
 * network fails), the dashboard renders an empty "No BI panels enabled"
 * state pointing the user to their Paelode account rep.
 */

import React from 'react';
import { VolumeTrendsPanel } from './bi-panels/VolumeTrendsPanel';
import { AcceptanceBySitePanel } from './bi-panels/AcceptanceBySitePanel';
import { DataExportPanel } from './bi-panels/DataExportPanel';

export function DisposalBiDashboard(): React.JSX.Element {
  const [volumeTrendsActive, setVolumeTrendsActive] = React.useState(true);
  const [acceptanceActive, setAcceptanceActive] = React.useState(true);
  const [dataExportActive, setDataExportActive] = React.useState(true);

  const noneActive = !volumeTrendsActive && !acceptanceActive && !dataExportActive;

  return (
    <main className="mx-auto max-w-6xl space-y-4 bg-background p-6 text-foreground">
      <div className="mb-6">
        <h1 className="text-xl font-semibold">Business Intelligence</h1>
        <p className="text-sm text-[var(--color-text-tertiary)]">
          Volume trends, site acceptance, and raw ticket exports for your facilities.
        </p>
      </div>

      {noneActive && (
        <div role="status" className="rounded-[var(--radius-card)] bg-card p-6 text-center">
          <p className="text-foreground">No BI panels enabled.</p>
          <p className="mt-2 text-sm text-[var(--color-text-tertiary)]">
            Contact your Paelode account representative to enable BI modules for your company.
          </p>
        </div>
      )}

      {volumeTrendsActive && (
        <VolumeTrendsPanel onModuleInactive={() => setVolumeTrendsActive(false)} />
      )}
      {acceptanceActive && (
        <AcceptanceBySitePanel onModuleInactive={() => setAcceptanceActive(false)} />
      )}
      {dataExportActive && <DataExportPanel onModuleInactive={() => setDataExportActive(false)} />}
    </main>
  );
}
